<template>
  <main>
    <b-navbar toggleable="lg" type="dark" variant="info" id="navbar" sticky>
      <b-navbar-brand href="#"><router-link to="/bmi-assessment-inputs"><font-awesome-icon id="font" icon="arrow-left" /></router-link><span id="span">{{$t('bmi_results')}}</span></b-navbar-brand>
    </b-navbar>
    <div id="main-container">
      <b-container class="mt-3 categories">
        <b-table small borderless :fields="fields" :items="Object.values(bmiCategories)" thead-class="d-none">
          <template #cell(Category)="data">
            <b v-if="data.value == bmiCategories[selectedCategory]['Category']"> {{$t(data.value)}} </b>
            <span style="font-size: 14px" v-else>{{ $t(data.value)}}</span>
          </template>
          <template #cell(Color)="data">
            <div v-bind:style="{'background-color': data.value}" id="colorBlock"></div>
          </template>
          <template #cell(Selected)="data">
            <h5 v-if="data.item.Category == bmiCategories[selectedCategory]['Category']"> <font-awesome-icon style="font-size: 20px" :icon="['fas', 'caret-left']" /> You </h5>
          </template>
        </b-table>
      </b-container>
      <b-container class="mt-2 text-center card p-2">
        <div class="card-body">
          <div class="card-title text-primary h6">
            {{$t('bmi_value_text')}}
          </div>
          <h2 class="card-text">{{bmiValue}} kg/m&#178;</h2>
        </div>
      </b-container>
      <b-container class="text-center card recommendation p-1">
        <div class="card-body">
          <h6 class="card-title">{{$t('recommend_header')}}</h6>
          <p v-if="selectedCategory == 'normal' && bmiValue >= 21" class="card-text">{{ $t(recommendationList[bmiCategories[selectedCategory]['Recommendation'][1]]) }}</p>
          <p v-else class="card-text">{{ $t(recommendationList[bmiCategories[selectedCategory]['Recommendation'][0]]) }}</p>
        </div>
      </b-container>
    </div>
    <div class="footer">
      <router-link to="bmi-statistics"><b-button id="button" class="float-right next"> {{$t('next')}}</b-button></router-link>
    </div>
  </main>
</template>

<script>
import { mapState } from 'vuex'
import { bmiCategories, recommendationList } from '../data/bmiData'
export default {
  name: 'BMIDisplay',
  data () {
    return {
      bmiCategories: bmiCategories,
      recommendationList: recommendationList,
      fields: [
        { key: 'Category', tdClass: 'float-right pr-4' },
        'Color',
        'Selected'
      ]
    }
  },
  computed: {
    ...mapState([
      'bmiValue',
      'selectedCategory'
    ])
  }
}
</script>
